import { API } from 'widget/helpers/axios';

export const sipEndpointAPI = {
    getSIPEndpoints(params) {
        return API.post("/api/v1/widget/sip", params);
    },
    async getIsVideoAvailable(inboxId, websiteToken, conversation_id) {
       const response = await API.get(`/api/v1/widget/calls/conversation_attributes`, {params: {website_token: websiteToken, inbox_id: inboxId, conversation_id: conversation_id}});

       return response;
    },
    async getToken(resource) {
        const response = await API.post("/api/v1/widget/sip/jwt_token", {
            sip : {
                resource: resource
            }
        });

        return response;
    },

    async refreshToken(refresh_token) {
        const response = await API.post("/api/v1/widget/sip/refresh_jwt_token", {
            sip : {
                refresh_token: refresh_token
            }
        });

        return response;
    }
};
